import React, { FC } from "react"
import { Spacer, StatusBubble } from "../../atoms/Atoms"
import { RRIconBar } from "../../atoms/roundedrectangle/RRIconBar"
import { RoundedRectangle } from "../../atoms/roundedrectangle/RoundedRectangle"
import L10n from "../../../../lib/carrot-l10n"
import { H3 } from "@carrotfertility/carotene"
import { BodySmall } from "../../atoms/Bodies"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"
import { CarrotCardModuleProps } from "components/views/molecules/CarrotCardModuleContainer"
import { getSupportCenterLink, SupportCenterLinks } from "../../../../utils/SupportCenterLinks"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const CarrotCardShippedModule: FC<CarrotCardModuleProps> = ({ backgroundColor }) => (
  <RoundedRectangle backgroundColor={backgroundColor}>
    <RRIconBar
      iconName="icn-carrot-cards"
      iconBackgroundColor="white-60"
      label={<StatusBubble backgroundColor="strong-cyan-blue" status={l`carrotCard.status.shipped`} />}
    />
    <H3 variant="dark" stack="tiny">{l`carrotCard`}</H3>
    <BodySmall color="black-80">{l`carrotCard.shipped`}</BodySmall>
    <Spacer height={0.5} />
    <ArrowLink target="_blank" to={getSupportCenterLink(SupportCenterLinks.CARROT_CARD_SUPPORT_CENTER)}>
      {l`How does the Carrot Card® work?`}
    </ArrowLink>
  </RoundedRectangle>
)

export { CarrotCardShippedModule }
